module.exports = __webpack_public_path__ + "img/icon-auto-registration3.4ad5eead.svg";